var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.redpackInfo.isShow && _vm.redpackInfo.goodRatio && !_vm.redpackInfo.isPromoterInBlack ? _c('div', {
    staticClass: "component-redpack-float",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.switchFloatStrip(false);
      }
    }
  }, [_c('div', {
    staticClass: "float-window",
    on: {
      "click": _vm.showActivityBox
    }
  }, [_c('ycf-image', {
    attrs: {
      "src": "/srcv2/images/redpack_float_window_20190228.png"
    }
  }), _vm._m(0)], 1), _c('div', {
    staticClass: "float-strip"
  }, [_c('div', {
    staticClass: "transition-content"
  }, [_vm._v("\n      " + _vm._s(_vm.isPromoter ? "自购" : "") + "下单最高返" + _vm._s(_vm.getReturnRedpack) + "元现金红包"), _c('i', {
    on: {
      "click": _vm.showActivityBox
    }
  }, [_vm._v("活动说明 ››")])])]), _vm.loadActivityExplanation ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showActivityExplanation,
      expression: "showActivityExplanation"
    }],
    staticClass: "Layer-FullScreen noticeType-Bulletbox activity-explanation",
    class: {
      'show-animation': _vm.showActivityExplanation,
      'fade-out': _vm.showOutAnimation
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.hideBox.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "main",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "title-text"
  }, [_c('ycf-image', {
    attrs: {
      "src": "/srcv2/images/activity_explanation_title_bg.png"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.isPromoter ? "自购" : "") + "下单最高返" + _vm._s(_vm.getReturnRedpack) + "元现金红包")])], 1), _c('div', {
    staticClass: "text-content"
  }, [_c('div', {
    staticClass: "text-scroll"
  }, [_c('p', {
    staticClass: "txt-p"
  }, [_vm._v("购买平台红包商品，最高可获实付金额50%的订单红包（" + _vm._s(_vm.redpackInfo.redPackageMoneyMax) + "元封顶），支付成功即刻发起助力活动，有效期24小时")]), _c('p', {
    staticClass: "txt-p"
  }, [_vm._v("任购一单，用户待解锁全部金额（帮助力获得）将与当前订单红包一并进入24小时倒计时状态，参与助力解锁现金活动（若购买非红包产品，则不返订单红包）")]), _c('p', {
    staticClass: "txt-p"
  }, [_vm._v("分享活动页给好友帮助力，每次助力，您都将随机解锁一部分现金24小时活动结束，剩余未解锁的红包金额全部失效")]), _c('p', {
    staticClass: "txt-p"
  }, [_vm._v("帮好友助力可获得待激活的“助力红包”，金额随机产生；每天只能助力2次，且同一个助力活动只能助力一次")]), _c('p', {
    staticClass: "txt-p"
  }, [_vm._v("助力解锁的金额可在下次消费抵扣现金，不可转让，出借，不得提现至银行卡及任何第三方平台")]), _c('p', {
    staticClass: "txt-p"
  }, [_vm._v("助力活动“解锁现金”定义为将“待激活”和“助力中”的红包转为“可使用”，仅作为云客赞平台消费时抵用")])]), _c('ycf-image', {
    attrs: {
      "src": "/srcv2/images/activity_explanation_translucent_mask.png"
    }
  })], 1), _c('div', {
    staticClass: "btn-define",
    on: {
      "click": _vm.hideBox
    }
  }, [_vm._v("确定")]), _c('p', {
    staticClass: "txt-prompt"
  }, [_vm._v("* 在个人中心-红包查看详情")])])]) : _vm._e()]) : _vm._e();
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "window-txt"
  }, [_c('p', {
    staticClass: "row-1"
  }, [_vm._v("赚")]), _c('p', {
    staticClass: "row-2"
  }, [_vm._v("现金")])]);
}];
export { render, staticRenderFns };